<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3817_250)">
      <path
        d="M17 9.88235V8.29412H7.54545L5.64516 6H1V9V17H9H12.5H17V13"
        stroke="#1D1E20"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 3V1H7.64516L9.54545 3.29412H18"
        stroke="#1D1E20"
        stroke-width="1.2"
        stroke-linecap="square"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3817_250">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>